module.exports = __webpack_public_path__ + "img/logo_lx.3bea4a47.png";